export const enum EventStatsLevel {
  Silver = 'silver',
  Gold = 'gold',
  Bronze = 'bronze',
  VIP = 'vip',
}
